import Vue from 'vue'
import { API_URL } from '../../api'
import PlanReportsFilter from '../../filters/PlanReportsFilter';
const state = {
    planReportCreate: {
        createdPlanReport: null,
        creatingPlanReport: false,
        createPlanReportStatus: null
    },
    planReportUpdate: {
        updatedPlanReport: null,
        updatingPlanReport: false,
        updatePlanReportStatus: null
    },
    planReportDelete: {
        deletingPlanReport: false,
        deletePlanReportStatus: null
    },
    planReportSearch: {
        planReportsCount: null,
        planReportsPaginated: [],
        planReports: [],
        searchingPlanReports: false,
        searchPlanReportStatus: null
    },
}
const mutations = {
    ['SET_PLAN_REPORT_CREATE'](state, change) {
        state.planReportCreate = { ...state.planReportCreate, ...change };
    },
    ['SET_PLAN_REPORT_UPDATE'](state, change) {
        state.planReportUpdate = { ...state.planReportUpdate, ...change };
    },
    ['SET_PLAN_REPORT_DELETE'](state, change) {
        state.planReportDelete = { ...state.planReportDelete, ...change };
    },
    ['SET_PLAN_REPORT_SEARCH'](state, change) {
        state.planReportSearch = { ...state.planReportSearch, ...change };
    },

}
const actions = {
    createPlanReport: ({ commit }, payload) => {
        commit('SET_PLAN_REPORT_CREATE', { createPlanReportStatus: null, createdPlanReport: null, creatingPlanReport: true })
        return Vue.http.post(API_URL + '/plan/reports/create', payload).then(response => {
            commit('SET_PLAN_REPORT_CREATE', { createPlanReportStatus: 'success', createdPlanReport: response.body.results.planReport });
        }).catch(response => {
            commit('SET_PLAN_REPORT_CREATE', { createPlanReportStatus: 'failed' });
        }).finally(() => {
            commit('SET_PLAN_REPORT_CREATE', { creatingPlanReport: false });
        });
    },
    updatePlanReport: ({ commit }, payload) => {
        commit('SET_PLAN_REPORT_UPDATE', { updatePlanReportStatus: null, updatedPlanReport: null, updatingPlanReport: true })
        return Vue.http.post(API_URL + '/plan/reports/update/' + payload.id, payload)
            .then(response => {
                commit('SET_PLAN_REPORT_UPDATE', { updatePlanReportStatus: 'success', updatedPlanReport: response.body.results.planReport });
            })
            .catch(response => {
                commit('SET_PLAN_REPORT_UPDATE', { updatePlanReportStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_PLAN_REPORT_UPDATE', { updatingPlanReport: false });
            })
    },
    deletePlanReport: ({ commit }, id) => {
        commit('SET_PLAN_REPORT_DELETE', { deletePlanReportStatus: null, deletedPlanReport: null, deletingPlanReport: true })
        return Vue.http.delete(API_URL + '/plan/reports/delete/' + id).then(response => {
            commit('SET_PLAN_REPORT_DELETE', { deletePlanReportStatus: 'success' });
        }).catch(response => {
            commit('SET_PLAN_REPORT_DELETE', { deletePlanReportStatus: 'failed' });
        }).finally(() => {
            commit('SET_PLAN_REPORT_DELETE', { deletingPlanReport: false });
        })
    },
    searchPlanReports: ({ commit }, payload = { filter: PlanReportsFilter(), resultMode: 'default' }) => {
        commit('SET_PLAN_REPORT_SEARCH', { searchPlanReportStatus: null, searchPlanReport: null, searchingPlanReports: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/plan/reports' + params).then(response => {
            if (payload.resultMode == 1) {
                commit('SET_PLAN_REPORT_SEARCH', { searchPlanReportStatus: 'success', planReportsCount: response.body.results.planReports });

            } else if (payload.resultMode == 2) {
                commit('SET_PLAN_REPORT_SEARCH', { searchPlanReportStatus: 'success', planReportsPaginated: response.body.results.planReports });

            } else {
                commit('SET_PLAN_REPORT_SEARCH', { searchPlanReportStatus: 'success', planReports: response.body.results.planReports });
            }
        }).catch(response => {
            commit('SET_PLAN_REPORT_SEARCH', { searchPlanReportStatus: 'failed' });
        }).finally(() => {
            commit('SET_PLAN_REPORT_SEARCH', { searchingPlanReports: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/planReportStore.js